import { withPrefix } from 'gatsby';
import React from 'react';
import { x } from '@xstyled/styled-components';
import { ScreenContainer } from 'smooth-doc/components';
import { Link } from './Link';
import SocialMedia from './SocialMedia';

export function AppFooter() {
  return (
    <x.div bg="#D8F0E9" fontFamily="cabin" lineHeight="default">
      <ScreenContainer px="4">
        <x.div
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          mx="-4"
          pt="4"
          pb="4"
          fontSize="sm"
        >
          <x.div px="4" pt="4" w={{ xs: '100%', md: 'auto' }}>
            <x.div pb="4">
              <Link external href="https://www.axiomatics.com" target="_blank">
                <img
                  src={withPrefix('/images/axiomatics_logo_full_256.png')}
                  alt="Axiomatics"
                />
              </Link>
            </x.div>
            <x.div maxW="15rem">
              The Visual Studio Code extension for ALFA was developed by
              Axiomatics.
            </x.div>
          </x.div>
          <x.div px="4" pt="4">
            <x.div pb="4" fontSize="lg" fontWeight="700">
              ABOUT
            </x.div>
            <x.div>
              <x.div>
                <Link
                  external
                  href="https://www.axiomatics.com/about-us/"
                  target="_blank"
                >
                  About Us
                </Link>
              </x.div>
              <x.div>
                <Link
                  external
                  href="https://www.axiomatics.com/contact-us/"
                  target="_blank"
                >
                  Contact Us
                </Link>
              </x.div>
            </x.div>
          </x.div>
          <x.div px="4" pt="4">
            <x.div pb="4" fontSize="lg" fontWeight="700">
              GET SUPPORT
            </x.div>
            <x.div>
              <x.a display="flex" href="mailto: support@axiomatics.com">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.6827 6C23.6827 4.9 22.6927 4 21.4827 4H3.88268C2.67268 4 1.68268 4.9 1.68268 6V18C1.68268 19.1 2.67268 20 3.88268 20H21.4827C22.6927 20 23.6827 19.1 23.6827 18V6ZM21.6827 6L12.6827 11L3.68268 6H21.6827ZM12.6827 13L3.68268 8V18H21.6827V8L12.6827 13Z"
                    fill="#0FA789"
                  />
                </svg>
                <x.span pl="2" color="black" textDecoration="underline">
                  support@axiomatics.com
                </x.span>
              </x.a>
            </x.div>
          </x.div>
          <x.div px="4" pt="4" w={{ xs: '100%', md: 'auto' }}>
            <x.div pb="4" fontSize="lg" fontWeight="700">
              FOLLOW US
            </x.div>
            <x.div>
              <SocialMedia />
            </x.div>
          </x.div>
        </x.div>
      </ScreenContainer>
      <x.div borderTop="1" borderColor="#7B99A1" />
      <ScreenContainer px="4">
        <x.div
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          mx="-4"
          py="2"
          fontSize="xs"
        >
          <x.div px="4" py="2">
            <x.span whiteSpace="nowrap">
              © Axiomatics {new Date().getFullYear()}
            </x.span>
          </x.div>
          <x.div py="2">
            <Link
              external
              href="https://www.axiomatics.com/privacy-policy/"
              target="_blank"
              whiteSpace="nowrap"
              px="4"
            >
              Privacy Policy
            </Link>
            <Link
              external
              href="https://www.axiomatics.com/cookie-notice/"
              target="_blank"
              whiteSpace="nowrap"
              px="4"
            >
              Cookies Policy
            </Link>
          </x.div>
        </x.div>
      </ScreenContainer>
    </x.div>
  );
}
